<template>
  <div class="content if-profile report-tab">
    <div class="md-layout if-profile-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
        <CRHeader :headerData="this.headerData" />
      </div>
      <div v-if="!isSample" class="md-layout-item md-size-100 p-0">
        <md-card class="if_card">
          <md-card-header class="md-card-header-icon">Data Input Upload</md-card-header>
          <md-card-content>
            <div class="extra_space">
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                  <!-- <h3>Data Input Upload</h3> -->
                  <ul>
                    <li>
                      Download the Bizminer Industry Financial Input
                      5-year Templateand save it offline as a CSV file.
                    </li>
                    <li>Populate the template offline</li>
                    <li>
                      Select the Choose File or Browse button to find
                      the populated CSV file on your device.
                    </li>
                    <li>
                      Use the Upload Inputs button to complete the
                      process.
                    </li>
                    <li>
                      Generate the report. Your financials will be
                      integrated; percentages, summary line items and
                      ratios will auto-calculate.
                    </li>
                  </ul>
                </div>

              </div>
              <div class="md-layout">
                <div class="md-layout-item p-0">
                  <upload-my-data></upload-my-data>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-100 report_form">
        <collapse :collapse="['Input']" icon="keyboard_arrow_down" color-collapse :active="true" class="input_form">
          <!-- <md-card class="if_card">
            <md-card-header>
              Input
          </md-card-header>-->
          <template slot="md-collapse-pane-1">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <div class="md-card m-0 multiples-text-card md-theme-default">
                <!-- <div class="md-card-header md-card-header-icon md-card-header-blue"></div> -->
                <div md-alignment="left">
                  <div v-if="loading">
                    <pulse-loader class="loading" :color="'blue'" :loading="loading"></pulse-loader>
                  </div>
                  <div v-if="inputStructure" class="field_group">
                    <div class="field_wpr" v-for="(item, index) in inputStructure" :key="index + 'inputStructure'">
                      <label>{{ item.title }}</label>
                      <md-field>
                        <md-input v-model="fields[item.field]"></md-input>
                      </md-field>
                      <!--<b>{{ item.title }}: </b>{{ item.info }}<br /> -->
                    </div>
                    <!-- <div class="field_wpr">
                          <md-button @click="saveInput($event)" class="md-raised md-primary">Save Input</md-button>
                    </div>-->
                  </div>
                </div>
              </div>
              <div class="section_end" v-if="!isSample">
                <md-button @click="saveInput($event)" class="md-raised md-info md-round">Save Input</md-button>
              </div>
            </div>
          </template>
          <!-- </md-card> -->
        </collapse>
      </div>
    </div>
  </div>
</template>

<script>
import CRHeader from './CRHeader.vue';
import { Collapse } from '@/components';
import axios from 'axios';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { mapActions, mapState } from 'vuex';
import UploadMyData from '@/components/UploadMyData.vue';

export default {
  components: {
    PulseLoader,
    CRHeader,
    Collapse,
    UploadMyData,
  },
  props: ['headerData'],
  data() {
    return {
      loading: false,
      fields: {
        company_name: '',
        company_city: '',
        company_state: '',
        company_zip: '',
        company_owner: '',
        company_phone: '',
        company_email: '',
        other_netSales: '',
        ft_emps: '',
        avg_annual_wage: '',
        other_grossProfit: '',
        other_offcomp: '',
        other_amortization: '',
        op_expenses: '',
        op_income: '',
        net_profit: '',
        acc_receivable: '',
        asset_otherCurrent: '',
        asset_total: '',
        liability_otherCurrent: '',
        liability_longTermDebt: '',
        liability_accountsPayable: '',
        days_recv: '',
        net_worth: '',
      },
    };
  },
  methods: {
    ...mapActions({
      alertSuccess: 'alerts/success',
      alertError: 'alerts/error',
      getCompanyReport: 'user/getCompanyReport',
    }),
    saveInput: async function (event) {
      event.stopPropagation();

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/report/save',
          {},
          {
            params: {
              type: 'company',
              session_id: currentSession,
              profile_id: this.profileId,
              company_name: this.fields['company_name'],
              company_city: this.fields['company_city'],
              company_state: this.fields['company_state'],
              company_zip: this.fields['company_zip'],
              company_owner: this.fields['company_owner'],
              company_phone: this.fields['company_phone'],
              company_email: this.fields['company_email'],
              other_netSales: this.fields['other_netSales'],
              ft_emps: this.fields['ft_emps'],
              avg_annual_wage: this.fields['avg_annual_wage'],
              other_grossProfit: this.fields['other_grossProfit'],
              other_offcomp: this.fields['other_offcomp'],
              other_amortization: this.fields['other_amortization'],
              op_expenses: this.fields['op_expenses'],
              op_income: this.fields['op_income'],
              net_profit: this.fields['net_profit'],
              acc_receivable: this.fields['acc_receivable'],
              asset_otherCurrent: this.fields['asset_otherCurrent'],
              asset_total: this.fields['asset_total'],
              liability_otherCurrent: this.fields['liability_otherCurrent'],
              liability_longTermDebt: this.fields['liability_longTermDebt'],
              liability_accountsPayable: this.fields[
                'liability_accountsPayable'
              ],
              days_recv: this.fields['days_recv'],
              net_worth: this.fields['net_worth'],
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/report/save" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.alertSuccess('Successfully saved!');
          this.$store.commit('SET_COMPANY_REPORT_SUMMARY', null);
          this.$router.push({
            name: "CRAbouttheData",
            params: this.$route.params.id,
          });
          this.$router.go()
        });
    },
    populateFields: function (data) {
      Object.keys(data).map((key) => {
        const field = data[key]['field'];
        const value = data[key]['value'];
        this.fields[field] = value;
      });
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    profileId() {
      return this.$route.params.id;
    },
    companyReport() {
      return this.$store.getters['user/companyReport'];
    },
    companyReportReleaseDisplay() {
      return this.$store.getters.companyReportReleaseDisplay;
    },
    inputStructure() {
      return this.companyReport
        ? Object.keys(this.companyReport.input_structure).map((key) => {
          return {
            title: key,
            info: this.companyReport.input_structure[key]['value'],
            field: this.companyReport.input_structure[key]['field'],
          };
        })
        : null;
    },
    isSample() {
      return this.$route.path.indexOf("sample") > -1
    },
  },
  async created() {
    this.populateFields(this.companyReport.input_structure);
  },
};
</script>

<style lang="scss">
.header-title {
  font-weight: bold;
  margin-top: 24px;
  font-size: 1.1rem;
}

.company-report-pdf {
  display: flex;
  justify-content: flex-end;
}

.summary-scores-box-star {
  .md-button-content {
    .md-icon {
      color: #3b7ef1;
    }
  }
}
</style>
